<script setup lang="ts">
import { getEmploymentTypes } from '@/javascripts/utils/inquiry_form_options';
import Inquiry from '@/javascripts/utils/inquiry';
import SlideIndicator from './slide_indicator.vue';

const emit = defineEmits(['next', 'back']);

const props = defineProps<{
  inquiry: Inquiry,
  currentSlideIndex: number,
}>();

const employmentTypes = getEmploymentTypes();

const emitNextIfUnchanged = function(clicked: number | string) {
  if (props.inquiry.employmentTypeCd == clicked) {
    emit('next');
  }
}
</script>

<template>
  <div class="inner_content inner_step">
    <div class="main_content step_content">
      <SlideIndicator :current-slide-index="currentSlideIndex" />
      <h2>あなたのご希望の雇用形態は？</h2>
      <div class="box_step_btn box_step_btn_p01">
        <div
          v-for="employmentType in employmentTypes"
          :key="employmentType.cd"
          class="step_btn"
        >
          <label :for="`emplyment_type_${employmentType.cd}`">
            <input
              :id="`emplyment_type_${employmentType.cd}`"
              v-model="inquiry.employmentTypeCd"
              type="radio"
              name="emplyment_type_cd"
              :value="employmentType.cd"
              @change="emit('next')"
              @click="emitNextIfUnchanged(employmentType.cd)"
            >
            <p>{{ employmentType.text }}</p>
          </label>
        </div>
      </div>
      <div class="box_btn_nextback">
        <div class="btn_back">
          <button @click.once="emit('back')">
            <span>戻る</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
